






















import { Component, Prop, Watch } from "vue-property-decorator";
import Vue from 'vue';
import AuthAuthenticator from '@/components/auth/auth-authenticator.vue';
import CustomAuthenticator from '@/components/auth/auth-custom-authenticator.vue'
import FabFeedback from '@/components/common/fab-feedback.vue';
import AppNav from '@/components/common/app-nav.vue';
//@ts-ignore
import { AmplifyEventBus } from 'aws-amplify-vue';
import { Auth } from 'aws-amplify';
import { getModule } from "vuex-module-decorators";
import UserAuth from "@/store/auth/UserAuth";
import Favourites from "@/store/Favourites";
import DecisionModule from "@/store/decision/Decision";
import ViewpointsModule from "@/store/viewpoint/viewpoint";
import Properties from "@/store/property/Properties";

@Component({
  components: {
    'fab-feedback': FabFeedback,
    'auth-authenticator': AuthAuthenticator,
    'auth-custom-authenticator': CustomAuthenticator,
    'app-nav': AppNav,
  }
})
export default class App extends Vue {

  private shareCodeProcess = false
  private forceLogin = false
  private dialog = false
  private confirmationCode = ''
  private confirmationUsername = ''
  private startingAuthState = ''
  private viewport = {
    width: 0,
    height: 0,
  }

  async mounted() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
    this.authLogin();
    await getModule(UserAuth).getUser()
    this.loadAllData()
  }


  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  }

  @Watch('screenWidth')
  watchScreenWidth(newVal: any) {
    console.log('[ Watch > screenWidth ]: ' + newVal);
    setTimeout(() => window.scrollBy(0, 1), 100);
    setTimeout(() => window.scrollBy(0, -1), 200);
  }

  @Watch('dialog')
  watchDialog(newVal: any) {
    if (newVal) {
      this.$emit('closeDialog');
    }
  }

  @Watch('refreshKey')
  watchRefreshKey(newVal: any) {
    this.loadAllData();
  }

  get screenWidth(): any {
    return this.viewport.width;
  }

  get refreshKey(): number {
    return this.$store.getters.getRefreshKey;
  }


  async loadAllData() {

    getModule(Favourites).getFavourites();
    getModule(DecisionModule).getDecision()
  }

  async clearData() {
    await getModule(ViewpointsModule).clear()
    await getModule(Properties).clear()
    await getModule(Favourites).clear()
    await getModule(DecisionModule).clear()
  }


  handleResize() {
    this.viewport.width = window.innerWidth;
    this.viewport.height = window.innerHeight;
  }


  async authLogin() {
    AmplifyEventBus.$on('authState', (info: any) => {
      if (info === 'confirmSignUp') {
      }
      if (info === 'signedIn') {
        getModule(UserAuth).getUser()
            .then(() => this.clearData()
                .then(() => this.loadAllData()))
        this.dialog = false;
      }
      if (info === 'signedOut') {
        getModule(UserAuth).signOut()
            .then(() => this.clearData()
                .then(() => this.loadAllData()));
      }
    });

  }
}


